import { getAuditEntryDocRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreAuditRepository extends BaseFirestoreRepository {
  async upsertEntity(entity, scope) {
    return this.upsert(
      getAuditEntryDocRef(this.db, entity.id),
      this.addStorageMarker({
        ...entity,
        organizationId: scope.organizationId,
        vesselId: scope.vesselId,
        voyageId: scope.voyageId || null,
        tripId: scope.tripId || null,
      })
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getAuditEntryDocRef(this.db, entityId));
  }
}
